import './LinkAttach.sass';

import React, { FC, useCallback, useMemo } from 'react';
import { useRoute } from 'react-router5';

import { LinkAttachProps } from './LinkAttach.interface';
import { classNames } from '$utils';
import { Button } from '$uikit';
import { ExternalVideo } from '$shared/components';
import router from '$navigation/router';
import { useLinkData } from '$hooks';
import { PersonalSubscriptionSnippet } from './PersonalSubscriptionSnippet/PersonalSubscriptionSnippet';
import { postsActions } from '$store/posts';
import { useDispatch } from 'react-redux';

export const LinkAttach: FC<LinkAttachProps> = ({
  link,
  mini,
  parentObject,
  attachmentsLength,
  adId = 0,
}) => {
  const { route } = useRoute();
  const linkData = useLinkData(link);
  const dispatch = useDispatch();

  if (!mini && link && link.type === 'external_video') {
    return <ExternalVideo link={link} parentObject={parentObject} adId={adId} />;
  }

  if (link && link.type === 'personal_subscription') {
    return (
      <PersonalSubscriptionSnippet
        link={link}
        isSingle={attachmentsLength === 1}
        adId={adId}
      />
    );
  }

  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    const { name, target, href } = linkData.linksOptions;

    e.stopPropagation();

    if (name) {
      router.navigate(route.name, {
        ...route.params,
        w: linkData.linksOptions.name,
      });
    } else if (href) {
      window.open(href, target || '_blank');
    }

    if (adId > 0) {
      dispatch(postsActions.sendAdConversion({ adId }));
    }
  };

  const description = useMemo(() => {
    let textParsed;
    if (linkData.description.substring(0, 1) === '{') {
      try {
        textParsed = JSON.parse(linkData.description).ops;
      } catch (e) {}
    }
    if (!textParsed) {
      textParsed = linkData.description;
    }

    if (typeof textParsed === 'string') {
      return textParsed;
    } else {
      let result = '';
      for (let item of textParsed) {
        result += item.insert;
      }
      return result;
    }
  }, [linkData.description]);

  return (
    <div
      className={classNames({
        LinkAttach: true,
        [link.type]: true,
      })}
      onClick={handleButtonClick}
    >
      <div className="LinkAttach__type">{linkData.type}</div>
      <div className="LinkAttach__body">
        <div
          className="LinkAttach__image"
          style={{ backgroundImage: `url(${linkData.image})` }}
        />
        <div className="LinkAttach__cont">
          <div className="LinkAttach__title">{linkData.title}</div>
          <div className="LinkAttach__description">{description}</div>
          <div className="LinkAttach__button">
            <Button size="small">{linkData.buttonText}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};
